import Vue from 'vue'
import Router from 'vue-router'
// 首页
import index from '@/pages/index/index'
// 内容页
import content from '@/pages/content/index'
import gbcont from '@/pages/gb/gbcont'
// 目录列表
import catelist from '@/pages/list/catelist'
// 搜索列表
import searchlist from '@/pages/list/searchlist'
// 个人中心基本资料
import baseinfo from '@/pages/people/baseinfo'
import nump from '@/pages/people/nump'
import approve from '@/pages/people/approve'
import address from '@/pages/people/address'
// 个人中心询价记录
import inquiryrecord from '@/pages/people/inquiryrecord'
// 个人中心订购记录
import orderrecord from '@/pages/people/orderrecord'
// 个人中心收藏记录
import collection from '@/pages/people/collection'
import collectiondetail from '@/pages/people/collectiondetail'
// 个人中心下载记录
import download from '@/pages/people/download'
// 个人中心我的消息
import myinfo from '@/pages/people/myinfo'
// 个人中心公告
import wzgg from '@/pages/people/wzgg'
import ggnotice from '@/pages/people/ggnotice'
// 网站公告
import noticeinfo from '@/pages/notice/noticeinfo'
import noticelist from '@/pages/notice/noticelist'
// 会员权益
import vipmember from '@/pages/notice/vipmember'
// 个人中心浏览记录
import history from '@/pages/people/history'
// 联系我们
import contact from '@/pages/notice/contact'
// 协议
import agreement from '@/pages/notice/agreement'
import vipagreement from '@/pages/notice/vipagreement'
import priagreement from '@/pages/notice/priagreement'
import cadagreement from '@/pages/notice/cadagreement'
// 企业
import icompany from '@/pages/company/icompany'
import cgoodslist from '@/pages/company/cgoodslist'
import creden from '@/pages/company/creden'
import newslist from '@/pages/company/newslist'
import newcont from '@/pages/company/newcont'
Vue.use(Router)
//路由重复（重复点击路由）
const originalPush = Router.prototype.push
   Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

export default new Router({
	mode:'history',
	routes: [{
			path: '/',
			name: 'index',
			component: index
		}, {
			path: '/content',
			name: 'content',
			component: content
		},  {
			path: '/gb/gbcont',
			name: 'gbcont',
			component: gbcont
		},
		{
			path: '/list/catelist',
			name: 'catelist',
			component: catelist
		}, {
			path: '/list/searchlist',
			name: 'searchlist',
			component: searchlist
		}, {
			path: '/people/baseinfo',
			name: 'baseinfo',
			component: baseinfo,
			meta:{
				requireAuth:true
			}
		}, {
			path: '/people/nump',
			name: 'nump',
			component: nump,
			meta:{
				requireAuth:true
			}
		},
		{
			path: '/people/approve',
			name: 'approve',
			component: approve,
			meta:{
				requireAuth:true
			}
		},
		{
			path: '/people/address',
			name: 'address',
			component: address,
			meta:{
				requireAuth:true
			}
		},
		{
			path: '/people/inquiryrecord',
			name: 'inquiryrecord',
			component: inquiryrecord,
			meta:{
				requireAuth:true
			}
		}, {
			path: '/people/orderrecord',
			name: 'orderrecord',
			component: orderrecord,
			meta:{
				requireAuth:true
			}
		}, {
			path: '/people/collection',
			name: 'collection',
			component: collection,
			meta:{
				requireAuth:true
			}
		}, {
			path: '/people/collectiondetail',
			name: 'collectiondetail',
			component: collectiondetail,
			meta:{
				requireAuth:true
			}
		}, {
			path: '/people/download',
			name: 'download',
			component: download,
			meta:{
				requireAuth:true
			}
		}, {
			path: '/people/myinfo',
			name: 'myinfo',
			component: myinfo,
			meta:{
				requireAuth:true
			}
		}, {
			path: '/people/wzgg',
			name: 'wzgg',
			component: wzgg,
			meta:{
				requireAuth:true
			}
		}, {
			path: '/people/ggnotice',
			name: 'ggnotice',
			component: ggnotice,
			meta:{
				requireAuth:true
			}
		},{
			path: '/notice/noticeinfo',
			name: 'noticeinfo',
			component: noticeinfo
		},{
			path: '/notice/noticelist',
			name: 'noticelist',
			component: noticelist
		},{
			path: '/notice/vipmember',
			name: 'vipmember',
			component: vipmember
		},{
			path: '/notice/contact',
			name: 'contact',
			component: contact
		},{
			path: '/notice/agreement',
			name: 'agreement',
			component: agreement
		},{
			path: '/notice/vipagreement',
			name: 'vipagreement',
			component: vipagreement
		},{
			path: '/notice/priagreement',
			name: 'priagreement',
			component: priagreement
		},{
			path: '/notice/cadagreement',
			name: 'cadagreement',
			component: cadagreement
		},{
			path: '/people/history',
			name: 'history',
			component: history,
			meta:{
				requireAuth:true
			}
		},{
			path: '/company/icompany',
			name: 'icompany',
			component: icompany,
			meta:{
				requireAuth:true
			}
		},{
			path: '/company/cgoodslist',
			name: 'cgoodslist',
			component: cgoodslist,
			meta:{
				requireAuth:true
			}
		},
		{
			path: '/company/creden',
			name: 'creden',
			component: creden,
			meta:{
				requireAuth:true
			}
		},
		{
			path: '/company/newslist',
			name: 'newslist',
			component: newslist,
			meta:{
				requireAuth:true
			}
		},
		{
			path: '/company/newcont',
			name: 'newcont',
			component: newcont,
			meta:{
				requireAuth:true
			}
		}
		 // { path: '*', component: NotFoundComponent }
		
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js